// extracted by mini-css-extract-plugin
export default {"img":"VendorComplete_img__KO+wN","button":"VendorComplete_button__IpMPp"};